/**
 * @name RespondAppointmentController
 * @description Controller for the respond modal
 * @param {library} $uibModalInstance Description
 * @param {service} Appointment The Appointment service
 * @param {resolve} appointment The resolved appointment
 * @param {resolve} project The resolved project
 * @param {resolve} shopMessageTemplates The resolved shopMessageTemplates
 * @param {service} Notification Description
 * @param {service} Session Description
 * @param {type} STATUS_IDS Description
 * @param {type} NOTIFICATIONS Description
 */
function RespondAppointmentController(
  $uibModalInstance,
  Appointment,
  appointment,
  project,
  shopMessageTemplates,
  Notification,
  Session,
  STATUS_IDS,
  NOTIFICATIONS
) {
  let vm = this;
  // Defaults
  vm.appointment = appointment;
  vm.project = project;
  vm.shopMessageTemplates = shopMessageTemplates;
  vm.agreedToCancellationPolicy = vm.appointment.agreed_to_cancellation_policy;
  vm.privacyPolicyIsCollapsed =
  vm.appointment.agreed_to_cancellation_policy;

  // Exposed Functions
  vm.confirmAppointment = confirmAppointment;
  vm.declineAppointment = declineAppointment;

  /**
  * @name confirm
  * @description Function to change the status of an appt to confirmed
  * @param {object} appointment The appointment to update.
  */
  function confirmAppointment() {
    let status = STATUS_IDS.confirmed;
    vm.appointment.agreed_to_cancellation_policy =
    vm.agreedToCancellationPolicy;
    Appointment.update(vm.appointment, status)
    .then(function(appointment) {
      $uibModalInstance.close(appointment);

      // Send appt notification when appointment is confirmed by collector
      let notification = {
        // Recipients of this email are determined in the API. The API will send
        // this email notification to all confirmed operators of the shop of the
        // appointment.
        notificationId: NOTIFICATIONS.appointmentConfirmedByCollector,
        messageObjects: {
          appointmentId: vm.appointment.id,
          projectId: vm.project.id,
          // The collector that confirmed the appointment
          collectorId: Session.collector.id,
          // The artist assigned to the appointment
          artistId: vm.appointment.artist.id
        },
        messageVariables: {
          subject: vm.project.collector.first_name + ' ' +
          vm.project.collector.last_name +
          ' confirmed their appointment on Ink Finder'
        }
      };
      Notification.send(notification);
    });
  }

  /**
  * @name decline
  * @description Function to change the status of an appt to declined
  * @param {object} appointment The appointment to update.
  */
  function declineAppointment() {
    let status = STATUS_IDS.declined;
    vm.appointment.agreed_to_cancellation_policy = false;
    Appointment.update(vm.appointment, status)
    .then(function(appointment) {
      $uibModalInstance.close(appointment);

      // Send appointment notification when appointment is declined by collector
      let notification = {
        // Recipients of this email are determined in the API. The API will send
        // this email notification to all confirmed operators of the shop of the
        // appointment.
        notificationId: NOTIFICATIONS.appointmentDeclinedByCollector,
        messageObjects: {
          appointmentId: vm.appointment.id,
          projectId: vm.project.id,
          // The collector that declined the appointment
          collectorId: Session.collector.id,
          // The artist assigned to the appointment
          artistId: vm.appointment.artist.id
        },
        messageVariables: {
          subject: vm.project.collector.first_name + ' ' +
          vm.project.collector.last_name +
          ' declined their appointment on Ink Finder'
        }
      };
      Notification.send(notification);
    });
  }

  vm.cancel = function() {
    $uibModalInstance.dismiss();
  };
}

angular
  .module('inkfinder')
  .controller('RespondAppointmentController', RespondAppointmentController);



// WEBPACK FOOTER //
// ./components/appointments/appointment/respond/respond.controller.js